/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface SuperAdminsControllerRemoveAsSuperAdmin$Params {
  id: string;

  /**
   * Store identifier for multi-tenant requests.
   */
  'terrific-store-id'?: string;
}

export function superAdminsControllerRemoveAsSuperAdmin(
  http: HttpClient,
  rootUrl: string,
  params: SuperAdminsControllerRemoveAsSuperAdmin$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, superAdminsControllerRemoveAsSuperAdmin.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('terrific-store-id', params['terrific-store-id'], {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

superAdminsControllerRemoveAsSuperAdmin.PATH = '/api/v1/users/super-admins/{id}';
